@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="Prüfpunkt auswählen"
           [ngModel]="filterText()"
           fullWidth
           [disabled]="true" />
  </nb-form-field>
} @else {
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput
           type="text"
           [(ngModel)]="filterText"
           placeholder="Prüfpunkt auswählen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth />
    @if (value) {
      <button nbSuffix nbButton ghost (click)="onClear()">
        <nb-icon icon="close-outline" pack="eva"></nb-icon>
      </button>
    }
  </nb-form-field>
}

<ng-template #popoverTemplate>
  <div class="autocomplete-dropdown">
    <nb-list>
      @if (showEmptyOption()) {
        <nb-list-item (click)="onAllSelected()">
          <div class="checkpoint-item alle">Alle</div>
        </nb-list-item>
      }
      @for (checkpoint of filteredCheckpoints(); track checkpoint.id) {
        <nb-list-item (click)="onSelectionChange(checkpoint)">
          <div class="checkpoint-item">{{ labelFor(checkpoint) }}</div>
        </nb-list-item>
      }
    </nb-list>
  </div>
</ng-template>
